import { addBooks } from "../actions";

const createBook = (book) => async (dispatch) => {
  const URL = "https://assignment4-bookstore-server-tanviranindo.glitch.me/books";

  const response = await fetch(URL, {
    method: "POST",
    headers: { "Content-Type": "application/json; charset=UTF-8" },
    body: JSON.stringify({ ...book, price: book.price, rating: book.rating })
  });

  const bookResponse = await response.json();

  if (response.status === 201) {
    dispatch(addBooks(bookResponse));
  }
};

export default createBook;
